module.exports = __webpack_public_path__ + "static/media/kia-minus.e32ca856.svg";